module.exports = __webpack_public_path__ + "img/ubm-logo.9151454d.png";